import { render, staticRenderFns } from "./CoBrandedPage.vue?vue&type=template&id=513a8b6a&scoped=true&"
import script from "./CoBrandedPage.vue?vue&type=script&lang=js&"
export * from "./CoBrandedPage.vue?vue&type=script&lang=js&"
import style0 from "./CoBrandedPage.vue?vue&type=style&index=0&id=513a8b6a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a8b6a",
  null
  
)

export default component.exports